import React from 'react';
import { motion } from 'framer-motion';
export function FadeIn({
  children,
  className = '',
  delay = 0
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-144">
      {children}
    </motion.div>;
}